/**
 * @description 链接跳转
 * @param {string} url 要跳转的链接
 * @param {boolean} ifBack 是否从首页返回
 * @param {boolean} isApplet 是否是小程序环境
 */
export const jumpUrl = (url, isApplet = true, ifBack = true, isRedirect = false) => {
    let pg = url.indexOf("/page");
    if (isApplet) {
        //小程序
        if (pg == 0) {
            //小程序链接
            const tabUrls = ["/page/home/index/index", "/page/home/mall/mall", "/page/home/order/order", "/page/home/myinfonew/myinfonew"];
            let len = tabUrls.length,
                isTab = false;
            for (var i = 0; i < len; i++) {
                if (url.indexOf(tabUrls[i]) != -1) {
                    isTab = true;
                    break;
                }
            }
            if (isTab) wx.miniProgram.switchTab({ url: url });
            else if (isRedirect) {
                wx.miniProgram.redirectTo({ url: url });
            } else {
                wx.miniProgram.navigateTo({ url: url });
            }
        } else {
            wx.miniProgram.navigateTo({
                url: `/page/home/webview/webview?src=${encodeURIComponent(url)}${ifBack ? "&showBack=1" : ""}`
            });
        }
    } else {
        //h5
        if (pg == 0) return;
        else location.href = url;
    }
};

// url参数search/hash转json
export const urlParamToJson = v => {
    let res;
    let myJson = {};
    let arr = v.slice(v.indexOf("?") + 1).split("&");
    for (var i = 0; i < arr.length; i++) {
        res = arr[i].split("=");
        myJson[res[0]] = res[1];
    }
    return myJson;
};

/**
 * @description 获取当前URL参数
 * @param {string?} name 参数名称，为null时 则以json的格式返回所有的参数信息
 * @return {string} string/json
 */
export const getUrlArg = name => {
    return getArgByUrl(location.href, name);
};

/**
 * @description 获取指定URL参数
 * @param {string?} url 为null时 则默认获取当前的URL
 * @param {string?} name 参数名称，为null时 则以json的格式返回所有的参数信息
 * @return {string} string/json
 */
export const getArgByUrl = (url, name) => {
    url = url || location.href;
    let urlObj = new URL(url);
    let searchReg = /(\/?\?)(.*?)(#\/|$)/;
    let search = url.match(searchReg) ? url.match(searchReg)[2] : "";

    let hashReg = /(#.*?\/?)(\?|$)(.*)/;
    let hash = url.match(hashReg) ? url.match(hashReg)[3] : "";

    let args = {
        ...urlParamToJson(search || urlObj.search),
        ...urlParamToJson(hash || urlObj.hash)
    };
    if (name != null) return args[name];
    return args;
};

/**
 * @description 获取当前可分享的URL
 * @param {string?} searchArg 需要携带的URL参数，可以是string/key[]/{key:val}
 * @return {string} url
 */
export const getShareUrl = function (searchArg, hasHash) {
    let protocol = location.protocol,
        host = location.host,
        url = `${protocol}//${host}${location.pathname}`;

    if (hasHash) {
        url += `/${location.hash}`;
    }
    if (searchArg) {
        if (typeof searchArg == "object") {
            let temp = searchArg;
            searchArg = "";
            if (Array.isArray(temp)) {
                let args = getUrlArg();

                for (let i in temp) {
                    let key = temp[i],
                        val = args[key];
                    if (val != null) searchArg += "&" + key + "=" + encodeURIComponent(val);
                }
            } else {
                for (let key in temp) {
                    let val = temp[key];
                    if (val != null) searchArg += "&" + key + "=" + encodeURIComponent(val);
                }
            }
        }
        if (searchArg[0] == "?" || searchArg[0] == "&") searchArg = searchArg.substring(1);
        if (searchArg) url += (url.indexOf("?") > -1 ? "&" : "?") + searchArg;
    }

    url = getViewportUrl(url);

    return url;
};

/**
 * @description 为url添加wv_viewport参数，目前主要适用于app渠道的UI兼容问题
 * @param {string} url
 * @return {string} url
 */
export const getViewportUrl = function (url) {
    let vp = "wv_viewport";
    if (url.indexOf(vp) > -1) return url;
    return url + (url.indexOf("?") > -1 ? "&" : "?") + vp;
};
